import type { CircleButtonProps } from './CircleButton';
import type { Ref } from 'react';

import { forwardRef } from 'react';
import { styled } from 'styled-components';

import { primaryButtonColorsAqua, primaryButtonColorsGreen } from '../PrimaryButton';

import { DefaultCircleButtonSC } from './CircleButton';

type Props = CircleButtonProps & {
  colorVariant?: 'green' | 'aqua';
};

const PrimaryCircleButtonSC = styled(DefaultCircleButtonSC)<{ $colorVariant?: 'green' | 'aqua' }>`
  ${(props) => {
    switch (props.$colorVariant) {
      case 'aqua':
        return primaryButtonColorsAqua;
      default:
        return primaryButtonColorsGreen;
    }
  }}
  box-shadow: 0px 3px 8px ${(props) => props.theme.colors.shadows.emeraldGreen[20]};
`;

export const PrimaryCircleButton = forwardRef(
  ({ colorVariant, icon, ...props }: Props, ref: Ref<HTMLButtonElement>) => {
    return (
      <PrimaryCircleButtonSC ref={ref} $colorVariant={colorVariant} {...props}>
        {icon}
      </PrimaryCircleButtonSC>
    );
  },
);
